import {Injectable} from '@angular/core'
@Injectable()

export class Inventarios {

}



// WEBPACK FOOTER //
// ./src/classes/inventarios.ts